import { render, staticRenderFns } from "./personalDetail.vue?vue&type=template&id=33024f76&scoped=true"
import script from "./personalDetail.vue?vue&type=script&lang=js"
export * from "./personalDetail.vue?vue&type=script&lang=js"
import style0 from "./personalDetail.vue?vue&type=style&index=0&id=33024f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33024f76",
  null
  
)

export default component.exports